import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

const pimUploadController = "api/v1/CustomETL";

export async function uploadDataFileAndGetMappings(fileName: string): Promise<any> {
    const response = await get<any>(`${pimUploadController}/ProcessUnmappedFile/${fileName}`);
    return response;
}

export function processMappedData(mappings: any): Promise<any> {
    return post<any, any>(`${pimUploadController}/ProcessMappedFile`, mappings);
}

export function getDestinationFields(): Promise<any> {
    return get<any>(`${pimUploadController}/GetDestinationFields`);
}

export function getMappingTypes(): Promise<string[]> {
    return get<any>(`${pimUploadController}/GetAvailableDataMappings`);
}

export function getExistingMappings(mappingType: string): Promise<any> {
    return get<any>(`${pimUploadController}/GetAvailableDataMappings/${mappingType}`);
}

export function getExistingMapping(mappingType: string, mappingName: string): Promise<any> {
    return get<any>(`${pimUploadController}/GetAvailableDataMappings/${mappingType}/${mappingName}`);
}

export function getAvailablePimJobFiles(): Promise<string[]> {
    return get<string[]>(`${pimUploadController}/GetAvailablePimJobFiles`);
}